import { render, staticRenderFns } from "./TeacherById.vue?vue&type=template&id=93384f40&scoped=true&"
import script from "./TeacherById.vue?vue&type=script&lang=js&"
export * from "./TeacherById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93384f40",
  null
  
)

export default component.exports